import { render, staticRenderFns } from "./menu-background.svg.vue?vue&type=template&id=6cfeaf78&"
import script from "./menu-background.svg.vue?vue&type=script&lang=js&"
export * from "./menu-background.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports